import { render, staticRenderFns } from "./PersonalReport.vue?vue&type=template&id=90a5ecbe&scoped=true&"
import script from "./PersonalReport.vue?vue&type=script&lang=js&"
export * from "./PersonalReport.vue?vue&type=script&lang=js&"
import style0 from "./PersonalReport.vue?vue&type=style&index=0&id=90a5ecbe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90a5ecbe",
  null
  
)

/* custom blocks */
import block0 from "./PersonalReport.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports